import ReferFriend from "./ReferFriend";

export default ReferFriend;
